import { createElement } from "@max/max";
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import { convertCentsToYuan2, MTfinStyle } from "@/utils/common";
import './index.scss';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
export default function FreeCardDrawResultPopup(props) {
    const systemType = getSystemType();
    const isAndroid = systemType === SystemType.android;
    const { winningOrderInfo } = props;
    if (!winningOrderInfo)
        return null;
    const { orderTitle: hotelOrderTitle, rewardAmount: hotelOrderPayMoney } = winningOrderInfo;
    return <View className="free-order-result">
      
      <LImage source={{
        uri: 'https://p0.meituan.net/ingee/e2def4abf2659a1899c4426ba1eb65437301.png'
    }} style={{
        width: '702rpx',
        height: '486rpx',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        borderRadius: '36rpx'
    }} width={rpx2px(702)} height={rpx2px(486)}>
        
        <View className="free-order-result-main-container">
          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/79e7b6dbc872cd79245bcbb5b18dfa714800.png'
    }} style={{
        width: '428rpx',
        height: '36rpx',
        marginTop: '30rpx'
    }} borderRadius={0}/>

          
          <Text className="free-order-result-order-info" numberOfLines={1}>
            订单：{hotelOrderTitle}
          </Text>

          
          <View className="free-order-result-amount-container" style={{
        top: isAndroid ? '-10rpx' : '0rpx'
    }}>
            <Text className="free-order-result-amount-symbol">¥</Text>
            <Text className="free-order-result-amount-value" style={Object.assign(Object.assign({}, MTfinStyle), { top: isAndroid ? '20rpx' : '0rpx' })}>
              {convertCentsToYuan2(hotelOrderPayMoney || 0, 2).integerPart}
            </Text>
            <Text className="free-order-result-amount-symbol" style={MTfinStyle}>.{convertCentsToYuan2(hotelOrderPayMoney || 0, 2).decimalPart}</Text>
          </View>

          
          <Text className="free-order-result-tip">
            离店后5个工作日返至【我的-余额】
          </Text>

          
          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/d6b55f56355cc795d102783e5d2c65fa30103.png'
    }} style={{
        width: '654rpx',
        height: '110rpx',
        marginTop: '35rpx'
    }} width={rpx2px(654)} height={rpx2px(110)} resizeMode='cover' onPress={props.onShareFreeCard}/>
        </View>
      </LImage>
  </View>;
}
